var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningWithCircleBackgroundWhite = function SvgWarningWithCircleBackgroundWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m33.208 17.771 15.573 26.932a1.111 1.111 0 0 1-.967 1.666H16.668c-.863 0-1.393-.93-.967-1.666L31.274 17.77a1.118 1.118 0 0 1 1.934 0Zm-3.562-.942c1.153-1.995 4.037-1.995 5.19 0L50.41 43.761c1.153 1.995-.289 4.489-2.596 4.489H16.668c-2.307 0-3.749-2.494-2.595-4.489L29.646 16.83Zm4.24 18.725a1.41 1.41 0 0 1-2.82 0V24.268a1.41 1.41 0 0 1 2.82 0v11.286Zm.471 6.113a1.881 1.881 0 1 1-3.762 0 1.881 1.881 0 0 1 3.762 0Z",
    fill: "#B4611B"
  })));
};
export default SvgWarningWithCircleBackgroundWhite;